import React from 'react';
import { Td, Tr } from '@chakra-ui/react';
import { prop, uniqBy } from 'ramda';
import { localise, pluralise } from '../../../services/lang/lang';
import { capitalise } from '../../../services/text/format';
import date from '../../../services/ui/date';
import ConditionalTooltip from '../Tooltip/ConditionalTooltip';
import ExpandableTableRow from '../Table/ExpandableTableRow';
import { useTokens } from '../../../context/TokenProvider';
import RemoteSubmissionsWrapper from './RemoteSubmissionsWrapper';
import { RenderIf } from '../RenderIf/RenderIf';
import TableExpandButton from '../Table/TableExpandButton';
import { useInspectionDetailContext } from '../../pages/upgrade/InspectionDetail/InspectionDetailProvider';
const RemoteSubmissionsTableRow = ({ data, isExpanded, canEdit, onRowClick, }) => {
    const tokens = useTokens();
    const { isShare } = useInspectionDetailContext();
    if (!data.remote_submissions?.length)
        return null;
    const findingCount = data.remote_submissions.length;
    const latestSubmssion = data.remote_submissions[0];
    const findingColumn = `${findingCount} ${capitalise(pluralise(localise('FINDING'), findingCount))}`;
    const contacts = uniqBy(prop('id'), data.remote_submissions.map((submission) => submission.contact));
    const hasMultipleContacts = contacts.length > 1;
    const contactRow = hasMultipleContacts
        ? localise('MULTIPLE')
        : `${contacts[0].full_name} (${contacts[0].type.name})`;
    return (React.createElement(React.Fragment, null,
        React.createElement(ExpandableTableRow, { isExpanded: isExpanded, "data-testid": "remote_submissions_table_row_row", onClick: onRowClick, isUnread: !data.read_at && !isShare },
            React.createElement(TableExpandButton, { isExpanded: isExpanded }),
            React.createElement(Td, { "data-testid": "remote_submissions_table_row__location" }, data.name),
            React.createElement(Td, { "data-testid": "remote_submissions_table_row__findings" }, findingColumn),
            React.createElement(Td, { "data-testid": "remote_submissions_table_row__contact" },
                React.createElement(ConditionalTooltip, { label: contacts.map((contact) => (React.createElement("div", { key: contact.id },
                        React.createElement("span", null,
                            contact.full_name,
                            " (",
                            contact.type.name,
                            ")")))), condition: hasMultipleContacts }, contactRow)),
            React.createElement(Td, { "data-testid": "remote_submissions_table_row__last_updated" }, date.standard(latestSubmssion.updated_at))),
        React.createElement(RenderIf, { condition: isExpanded },
            React.createElement(Tr, { bgColor: tokens.Layer01 },
                React.createElement(Td, { px: 0, colSpan: 5 },
                    React.createElement(RemoteSubmissionsWrapper, { canEdit: canEdit, remoteSubmissions: data.remote_submissions }))))));
};
export default RemoteSubmissionsTableRow;
